module.exports = __webpack_public_path__ + "static/media/management.1c28d25b.svg";